import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllVariacaoResponse } from '../../responses/produto/get-all-variacao.response';
import { GetVariacaoResponse } from '../../responses/produto/get-variacao.response';
import { VariacaoRequest } from '../../requests/produto/variacao.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class VariacaoService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    // Updated endpoint as per user request
    private readonly apiUrl = `${environment.urlApiProduto}variacoesproduto`;

    /**
     * Obtém a lista de Variações.
     * Corresponde a: [HttpGet]
     */
    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllVariacaoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetAllVariacaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma variação.
     * Corresponde a: [HttpDelete]
     * @param idVariacao O ID da variação a ser excluída.
     */
    public delete(idVariacao: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idVariacao}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas variações.
     * Corresponde a: [HttpPost/bulk-delete]
     * @param idsVariacao Lista de IDs das variações a serem excluídas.
     */
    public deleteBulk(idsVariacao: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsVariacao }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma variação por ID.
     * Corresponde a: [HttpGet/:id]
     * @param idVariacao O ID da variação.
     */
    public getById(idVariacao: number): Observable<GetVariacaoResponse> {
        const url = `${this.apiUrl}/${idVariacao}`;

        return this.httpClient
            .get<GetVariacaoResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova variação.
     * Corresponde a: [HttpPost]
     * @param request Os dados da variação a ser criada.
     */
    public create(request: VariacaoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma variação existente.
     * Corresponde a: [HttpPut/:id]
     * @param idVariacao O ID da variação a ser atualizada.
     * @param request Os dados atualizados da variação.
     */
    public update(idVariacao: number, request: VariacaoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idVariacao}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
